/** Fit actions use the actual docked viewport; dimensions remain transient UI information. */
export function workspaceViewportOptions(element: HTMLElement | null) {
  const surface = element?.closest('.workspace-shell')?.querySelector<HTMLElement>('.map-surface');
  return surface && surface.clientWidth > 0 && surface.clientHeight > 0
    ? { viewportWidth: surface.clientWidth, viewportHeight: surface.clientHeight }
    : {};
}
